import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ACCentralDetail from '../../components/ac_central/ACCentralDetail';
import { defaultRejectHandler } from '../../utils/utility';
import {
  getACCentral,
  editACCentral,
} from '../../redux/ac_central/ac_central_actions';

class ACCentralEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.acDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ac !== nextProps.ac && nextProps.show) {
      this.props.getAC(nextProps.ac.id);
    }
  }

  onSaveHandler() {
    const editedAC = this.acDetail.getWrappedInstance().getWrappedInstance().getACData();
    this.props.editAC({
      ...editedAC,
      id: this.props.ac.id,
    });
  }

  render() {
    const { isEditing, errorMessage, acDetail, t, getAC, editAC, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit a/c central')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ACCentralDetail
            ac={acDetail}
            mode={'edit'}
            ref={ref => (this.acDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-central-unit-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.central.errorMessage,
  isEditing: state.ac.central.isEditing,
  acDetail: props.ac && state.ac.central.objects[props.ac.id],
});

const mapDispatchToProps = dispatch => ({
  editAC: ac => defaultRejectHandler(dispatch(editACCentral(ac.id, ac.name, ac.description, ac.image))),
  getAC: id => defaultRejectHandler(dispatch(getACCentral(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACCentralEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/ACCentralEditModal.js